export default __webpack_public_path__ + "static/eco_packaging_white-cf07e992c668cd5707e8fa7056e1f402.svg";